import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeService from './HomeService';

const HomeServices = () => {
    const [services, setServices] = useState([])
    useEffect(() => {
        fetch('https://assignment-11-server-sooty.vercel.app/home/services')
            .then(res => res.json())
            .then(data => setServices(data))
    }, [])
    return (
        <div className='my-5'>
            <h1 className='text-center text-5xl my-5'>Services</h1>
            <div className='grid lg:px-4 lg:grid-cols-3 gap-4 sm:p-5 mx-auto w-full mb-5'>
                {
                    services.map(service => <HomeService
                        key={service._id}
                        service={service}
                    >

                    </HomeService>)
                }
            </div>
            <div className='text-center'>
                <Link to='/services'><button className="btn btn-active btn-primary">Show All</button></Link>
            </div>
        </div>
    );
};

export default HomeServices;